module.exports = __webpack_public_path__ + "static/media/colored_logo.dc5ba6cf.png";